import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Divider from "@mui/material/Divider";
import { getNotices, INoticesRow } from "../../webapi/service/getNotices";
import AuthService from "../../common/AuthService";
import Popover from "@mui/material/Popover";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListSubheader from "@mui/material/ListSubheader";
import Link from "@mui/material/Link";
import { selectNotice } from "../notice/NoticeMainSpace";
import "../main.css";

export interface IProps extends WithTranslation {
  /**
   * 認証サービス
   */
  authService?: AuthService;
  /**
   * 通知件数
   */
  noticeCount: number;
  /**
   * 通知項目が選択された場合に呼び出されます
   */
  onNotice: (data: INoticesRow | undefined) => void;
  /**
   * 通信エラーが発生した場合に呼び出します
   * @param id - メッセージID
   * @param status - httpステータスコード
   */
  onCommunicationError: (
    id: string | undefined,
    status: number | undefined
  ) => void;
}

interface IState {
  anchorEl: null | HTMLElement;
  notices: INoticesRow[];
}

class NoticeIcon extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = { anchorEl: null, notices: [] };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleClickItem = this.handleClickItem.bind(this);
    this.handleClickNoticeList = this.handleClickNoticeList.bind(this);
  }

  handleOpen(event: React.MouseEvent<HTMLButtonElement>) {
    const { authService, i18n, onCommunicationError } = this.props;
    const { currentTarget } = event;
    getNotices({
      authService: authService,
      lang: i18n.language,
      unread: "true",
      success: (data) => {
        //console.log(data);
        this.setState({ anchorEl: currentTarget, notices: data });
      },
      fail: (id, status) => {
        onCommunicationError(id, status);
      },
    });
  }

  handleClose() {
    this.setState({ anchorEl: null });
  }

  handleClickItem(id: string) {
    const notice = this.state.notices.find((notice) => {
      return notice.noticeid === id;
    });
    this.setState({ anchorEl: null });
    if (notice) {
      selectNotice({
        authService: this.props.authService,
        notice: notice,
        onNotice: this.props.onNotice,
        onCommunicationError: this.props.onCommunicationError,
      });
    }
  }

  handleClickNoticeList() {
    this.setState({ anchorEl: null });
    this.props.onNotice(undefined);
  }

  render() {
    const { noticeCount, t } = this.props;
    const { anchorEl, notices } = this.state;
    const open = Boolean(anchorEl);
    const noticeItems = notices.map((notice, i) => {
      return (
        <React.Fragment key={i++}>
          <Divider />
          <ListItemButton
            key={i}
            onClick={() => this.handleClickItem(notice.noticeid)}
          >
            {notice.message}
            <br />
            {notice.projectname}
            <br />
            {notice.noticetime}
          </ListItemButton>
        </React.Fragment>
      );
    });
    const unreadNoticeNone = this.state.notices.length === 0 ?
      <div style={{ padding: "16px" }}>{t("notifications_none")}</div> : "";
    return (
      <div>
        <IconButton
          size="large"
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          color="inherit"
          onClick={this.handleOpen}
        >
          <Badge badgeContent={noticeCount} color="error">
            <NotificationsNoneIcon />
          </Badge>
        </IconButton>
        <Popover
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          PaperProps={{
            style: {
              maxHeight: 300,
            },
          }}
        >
          <List
            subheader={
              <ListSubheader onClick={this.handleClickNoticeList}>
                <Link href="#" onClick={this.handleClickNoticeList}>
                  {t("notifications_all")}
                </Link>
              </ListSubheader>
            }
          >
            {noticeItems}
            {unreadNoticeNone}            
          </List>
        </Popover>
      </div>
    );
  }
}

export default withTranslation()(NoticeIcon);
